import { AsyncStoreItem } from '@lib/store';
import { GetRequiredMilesResponse } from 'src/sdk-member';

/**
 * GetRequiredMiles model
 */
export interface GetRequiredMilesModel {
  model: GetRequiredMilesResponse | null;
}

/**
 * GetRequiredMilesResponse model details
 */
export interface GetRequiredMilesStateDetails extends AsyncStoreItem {}

/**
 * GetRequiredMiles store state
 */
export interface GetRequiredMilesState extends GetRequiredMilesStateDetails, GetRequiredMilesModel {}

/**
 * Name of the GetRequiredMiles Store
 */
export const GET_REQUIRED_MILES_STORE_NAME = 'getRequiredMiles';

/**
 * GetRequiredMiles Store Interface
 */
export interface GetRequiredMilesStore {
  /** GetRequiredMiles state */
  [GET_REQUIRED_MILES_STORE_NAME]: GetRequiredMilesState;
}
